"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connection = void 0;
const signers_1 = require("@near-js/signers");
const providers_1 = require("@near-js/providers");
const depd_1 = __importDefault(require("depd"));
/**
 * @param config Contains connection info details
 * @returns {Provider}
 */
function getProvider(config) {
    switch (config.type) {
        case undefined:
            return config;
        case "JsonRpcProvider":
            return new providers_1.JsonRpcProvider({ ...config.args });
        case "FailoverRpcProvider": {
            const providers = (config?.args || []).map((arg) => new providers_1.JsonRpcProvider(arg));
            return new providers_1.FailoverRpcProvider(providers);
        }
        default:
            throw new Error(`Unknown provider type ${config.type}`);
    }
}
/**
 * @param config Contains connection info details
 * @returns {Signer}
 */
function getSigner(config) {
    switch (config.type) {
        case undefined:
            return config;
        case "KeyPairSigner": {
            return new signers_1.KeyPairSigner(config.keyPair);
        }
        default:
            throw new Error(`Unknown signer type ${config.type}`);
    }
}
/**
 * @deprecated
 *
 * Connects an account to a given network via a given provider
 */
class Connection {
    networkId;
    provider;
    signer;
    constructor(networkId, provider, signer) {
        const deprecate = (0, depd_1.default)('new Connection(networkId, provider, signer)');
        deprecate('`Connection` is no longer used anywhere, please switch to constructing `Account` without it - use `new Account(accountId, provider, signer)`');
        this.networkId = networkId;
        this.provider = provider;
        this.signer = signer;
    }
    getConnection() {
        return this;
    }
    /**
     * @param config Contains connection info details
     */
    static fromConfig(config) {
        const provider = getProvider(config.provider);
        const signer = getSigner(config.signer);
        return new Connection(config.networkId, provider, signer);
    }
}
exports.Connection = Connection;
